// extracted by mini-css-extract-plugin
export default {"testimonials":"Testimonial_testimonials__aUqCj","content":"Testimonial_content__N0r9a"};